/* eslint-disable react/forbid-prop-types */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import debounce from 'lodash/debounce';

import { Form } from 'core/forms';

import { Loading } from 'uikit/loaders';

import styles from '../styles/videosPermissionsAutoSave.module.scss';

const VideosPermissionsAutoSave = ({
  className,
  onAutoSave,
  autoSaveDelay,
  onFormUpdate,
  model,
  schema,
  onError,
}) => {
  const [isSubmittingForm, setSubmittingForm] = useState(false);
  const [isModelModified, setIsModelModified] = useState(false);

  const saveForm = async (updatedModel) => {
    setSubmittingForm(true);
    try {
      await onAutoSave(updatedModel);
      setIsModelModified(false);
    } catch (error) {
      onError(error);
    }
    setSubmittingForm(false);
  };

  const debouncedSaveForm = useCallback(debounce(saveForm, autoSaveDelay), []);

  const handleFormUpdate = (onFormUpdateArgs) => {
    const { update, hasError } = onFormUpdateArgs;
    const updatedModel = { ...model, ...update };

    onFormUpdate(onFormUpdateArgs);
    if (!hasError) {
      setIsModelModified(true);
      debouncedSaveForm(updatedModel);
    }
  };

  return (
    <section
      className={classnames(styles.element, className, {
        [styles.isModelModified]: isModelModified,
      })}
    >
      <div className={styles.formContainer}>
        <Form model={model} schema={schema} onUpdate={handleFormUpdate} />
      </div>
      {isSubmittingForm && <Loading className={styles.loading} />}
    </section>
  );
};

VideosPermissionsAutoSave.propTypes = {
  className: PropTypes.string,
  autoSaveDelay: PropTypes.number,
  onFormUpdate: PropTypes.func,
  model: PropTypes.objectOf(PropTypes.any).isRequired,
  schema: PropTypes.objectOf(PropTypes.any).isRequired,
  onError: PropTypes.func,
};

VideosPermissionsAutoSave.defaultProps = {
  className: '',
  autoSaveDelay: 1000,
  onFormUpdate: () => {},
  onError: () => {},
};

export default VideosPermissionsAutoSave;
